import React from 'react'
import { Stack, Typography } from '@mui/material'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'

interface Props {
  item?: InstallationInvitationModel
}
const AccountLinkNameColumn: React.VFC<Props> = ({ item }) => {
  if (item) {
    return (
      <Stack direction={'column'} justifyContent={'center'}>
        <Typography variant={'body2'}>{item.accountId}</Typography>
      </Stack>
    )
  }

  return <span>-</span>
}

export default AccountLinkNameColumn
